var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c("validation-observer", {
                ref: "EditServiceTemplate",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var invalid = ref.invalid
                      return [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.formSubmitted($event)
                              },
                              change: function ($event) {
                                return _vm.formChanged()
                              },
                            },
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Template Name*",
                                          "label-for": "mc-Template-name",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules:
                                              "required|alphanumeric_spaces|min:3|max:100",
                                            customMessages: {
                                              min: "The Template Name must be at least 3 character(s).",
                                            },
                                            name: "Template Name",
                                            vid: "Template Name",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "mc-Template-name",
                                                        type: "text",
                                                        required: "",
                                                        placeholder:
                                                          "Enter your template name",
                                                        state:
                                                          errors.length > 0
                                                            ? false
                                                            : null,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .ServiceTemplateObject
                                                            .orderName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.ServiceTemplateObject,
                                                            "orderName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "ServiceTemplateObject.orderName",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Description",
                                          "label-for":
                                            "mc-Template-Description",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "min:3|max:250",
                                            customMessages: {
                                              min: "The Description must be at least 3 character(s).",
                                            },
                                            name: "Description",
                                            vid: "Description",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        type: "text",
                                                        id: "mc-Template-Description",
                                                        placeholder:
                                                          "Enter your description",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .ServiceTemplateObject
                                                            .orderDescription,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.ServiceTemplateObject,
                                                            "orderDescription",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "ServiceTemplateObject.orderDescription",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "3" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Selling Price",
                                          "label-for": "mc-Budget",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules:
                                              "required|price_Validation|min:1|min_value:0",
                                            name: "SellingPrice",
                                            vid: "SellingPrice",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "mc-Budget",
                                                        step: "0.01",
                                                        placeholder:
                                                          "Enter your selling price",
                                                        type: "number",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .ServiceTemplateObject
                                                            .budget,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.ServiceTemplateObject,
                                                            "budget",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "ServiceTemplateObject.budget",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "3" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label:
                                            "Estimated Duration (In Hours)",
                                          "label-for": "mc-Estimated-Duration",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules:
                                              "numeric_decimal|min_value:0",
                                            name: "Estimated Duration",
                                            vid: "Estimated Duration",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "mc-Estimated-Duration",
                                                        placeholder:
                                                          "Enter your estimated duration",
                                                        type: "number",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .ServiceTemplateObject
                                                            .estimatedDuration,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.ServiceTemplateObject,
                                                            "estimatedDuration",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "ServiceTemplateObject.estimatedDuration",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Staff*",
                                          "label-for": "mc-staff",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required",
                                            name: "Staff",
                                            vid: "Staff",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-select", {
                                                      attrs: {
                                                        taggable: "",
                                                        multiple: "",
                                                        "push-tags": "",
                                                        placeholder:
                                                          "Add staff",
                                                        label: "name",
                                                        "menu-props":
                                                          "{ auto: true, offsetY: true, maxHeight: '200px' }",
                                                        attach: "body",
                                                        options:
                                                          _vm.staffpopulate,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.selectedStaff,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.selectedStaff =
                                                            $$v
                                                        },
                                                        expression:
                                                          "selectedStaff",
                                                      },
                                                    }),
                                                    errors.length
                                                      ? _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "validation-observer",
        { ref: "addProduct" },
        [
          _c(
            "b-modal",
            {
              ref: "addProductModal",
              attrs: {
                id: "modal-addProduct",
                "hide-footer": true,
                centered: "",
                title: "Add Product",
              },
            },
            [
              _c(
                "b-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleProdSubmit($event)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("label", { attrs: { for: "name" } }, [
                                _vm._v("Name:"),
                              ]),
                              _c("validation-provider", {
                                attrs: { rules: "required", name: "name" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "name",
                                            type: "text",
                                            placeholder: "Name",
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.products.ProductId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.products,
                                                "ProductId",
                                                $$v
                                              )
                                            },
                                            expression: "products.ProductId",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("label", { attrs: { for: "qty" } }, [
                                _vm._v("Quantity:"),
                              ]),
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required|numeric|min_value:0",
                                  name: "qty",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "qty",
                                            type: "number",
                                            placeholder: "Quantity",
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.products.Quantity,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.products,
                                                "Quantity",
                                                $$v
                                              )
                                            },
                                            expression: "products.Quantity",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-end" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(113, 102, 240, 0.15)",
                                  expression: "'rgba(113, 102, 240, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              attrs: { variant: "primary" },
                              on: { click: _vm.addProduct },
                            },
                            [_vm._v(" Save ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.HasPermission(_vm.PermissionList.Inventory_Create)
        ? _c(
            "b-card",
            [
              _c("validation-observer", {
                ref: "itemObserver",
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var invalid = ref.invalid
                        return [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c("h3", { staticClass: "mb-2" }, [
                                  _vm._v("Item Details"),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              ref: "itemForm",
                              staticClass: "repeater-form",
                              style: { height: _vm.itemFormHeight },
                            },
                            _vm._l(
                              _vm.invoiceData.items,
                              function (item, index) {
                                return _c(
                                  "b-row",
                                  {
                                    key: index,
                                    ref: "row",
                                    refInFor: true,
                                    staticClass:
                                      "align-items-center border rounded m-0 mb-2 p-2",
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        attrs: { cols: "12", sm: "6", md: "6" },
                                      },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            options: _vm.optionsProduct,
                                            label: "itemTitle",
                                            placeholder: "Select Item",
                                            "append-to-body": "",
                                            "menu-props":
                                              "{ auto: true, offsetY: true, maxHeight: '200px' }",
                                            attach: "body",
                                          },
                                          on: {
                                            input: function (val) {
                                              return _vm.updateItemForm(
                                                index,
                                                val
                                              )
                                            },
                                          },
                                          model: {
                                            value: item.id,
                                            callback: function ($$v) {
                                              _vm.$set(item, "id", $$v)
                                            },
                                            expression: "item.id",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      {
                                        attrs: { cols: "12", sm: "4", md: "4" },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required|min_value:0.00001",
                                            name: "Quantity",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        required: "",
                                                        type: "text",
                                                        step: "0.00001",
                                                      },
                                                      on: {
                                                        blur: _vm.autoCorrectQty,
                                                        keypress:
                                                          _vm.onlyDigits,
                                                      },
                                                      model: {
                                                        value: item.qty,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "qty",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.qty",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center align-items-center",
                                        attrs: { cols: "12", sm: "2", md: "1" },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "d-flex align-items-center px-2",
                                            attrs: {
                                              size: "sm",
                                              variant: "outline-danger",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeItem(
                                                  index,
                                                  "item"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mr-1" },
                                              [_vm._v("×")]
                                            ),
                                            _vm._v(" Delete "),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          ),
                          _c(
                            "b-row",
                            { staticClass: "align-items-center" },
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(255, 255, 255, 0.15)",
                                          expression:
                                            "'rgba(255, 255, 255, 0.15)'",
                                          modifiers: { 400: true },
                                        },
                                      ],
                                      staticClass: "mt-2 mr-2",
                                      attrs: { size: "sm", variant: "primary" },
                                      on: { click: _vm.addNewItemInItemForm },
                                    },
                                    [_vm._v(" Add Item ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  146744555
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("h3", { staticClass: "mb-2" }, [
                      _vm._v("Tasks Details*"),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "div",
                    [
                      _c(
                        "validation-observer",
                        { ref: "EditServiceTemplateDetails" },
                        [
                          _c(
                            "b-form",
                            {
                              ref: "taskForm",
                              staticClass: "repeater-form",
                              style: { height: _vm.taskFormHeight },
                            },
                            _vm._l(_vm.items, function (item, index) {
                              return _vm.items.length > 0
                                ? _c(
                                    "b-row",
                                    {
                                      key: item.id,
                                      ref: "row",
                                      refInFor: true,
                                      staticClass: "mb-2",
                                      attrs: { id: item.id },
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { md: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Tasks*",
                                                "label-for": "item-tasks",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                ref: "taskProvider",
                                                refInFor: true,
                                                staticClass: "mb-4",
                                                attrs: {
                                                  rules:
                                                    "required|min:3|max:250",
                                                  customMessages: {
                                                    min: "task must be at least 3 character(s).",
                                                  },
                                                  vid: "task_" + index,
                                                  name: "Tasks",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        var validate =
                                                          ref.validate
                                                        return [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id:
                                                                "item-tasks_" +
                                                                index,
                                                              type: "text",
                                                              placeholder:
                                                                "Enter your tasks",
                                                            },
                                                            on: {
                                                              blur: validate,
                                                            },
                                                            model: {
                                                              value: item.tasks,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "tasks",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.tasks",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "2" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Resources*",
                                                "label-for": "resources",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                ref: "resourcesProvider",
                                                refInFor: true,
                                                attrs: {
                                                  rules:
                                                    "required|min:0|max:250",
                                                  vid: "resources_" + index,
                                                  name: "Resources",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        var validate =
                                                          ref.validate
                                                        return [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id:
                                                                "resources_" +
                                                                index,
                                                              type: "text",
                                                              placeholder:
                                                                "Enter your resources",
                                                            },
                                                            on: {
                                                              blur: validate,
                                                            },
                                                            model: {
                                                              value:
                                                                item.resources,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "resources",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.resources",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "2" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Tools*",
                                                "label-for": "tools",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                ref: "toolsProvider",
                                                refInFor: true,
                                                attrs: {
                                                  rules:
                                                    "required|min:0|max:250",
                                                  vid: "tools_" + index,
                                                  name: "Tools",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        var validate =
                                                          ref.validate
                                                        return [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id:
                                                                "tools_" +
                                                                index,
                                                              type: "text",
                                                              placeholder:
                                                                "Enter your tools",
                                                            },
                                                            on: {
                                                              blur: validate,
                                                            },
                                                            model: {
                                                              value: item.tools,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "tools",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.tools",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "2", md: "1" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Cost",
                                                "label-for": "price",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                ref: "priceProvider",
                                                refInFor: true,
                                                attrs: {
                                                  rules:
                                                    "numeric_decimal|min_value:0",
                                                  vid: "price_" + index,
                                                  name: "Price",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        var validate =
                                                          ref.validate
                                                        return [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id:
                                                                "price_" +
                                                                index,
                                                              type: "number",
                                                              placeholder:
                                                                "Enter your price",
                                                            },
                                                            on: {
                                                              blur: validate,
                                                            },
                                                            model: {
                                                              value: item.price,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "price",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.price",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mb-50",
                                          attrs: { lg: "2", md: "3" },
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "mt-0 mt-md-2",
                                              attrs: {
                                                variant: "outline-danger",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeItem(
                                                    index,
                                                    "task"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                staticClass: "mr-25",
                                                attrs: { icon: "XIcon" },
                                              }),
                                              _c("span", [_vm._v("Delete")]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.items.length > 1
                                        ? _c(
                                            "b-col",
                                            { attrs: { cols: "12" } },
                                            [_c("hr")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(255, 255, 255, 0.15)",
                          expression: "'rgba(255, 255, 255, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      staticClass: "mt-1",
                      attrs: { variant: "primary" },
                      on: { click: _vm.AddNew },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-25",
                        attrs: { icon: "PlusIcon" },
                      }),
                      _c("span", [_vm._v("Add New")]),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { variant: "outline-primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.formSubmitted()
                                },
                              },
                            },
                            [_vm._v("Update")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c("DocumentUpload", {
                attrs: { documentDetails: _vm.documentDetails },
                on: {
                  deleteFile: _vm.deleteFile,
                  downloadFile: _vm.downloadFile,
                  uploadFiles: _vm.uploadFiles,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }